import React from 'react'

export const SettingsView = () => {
  return (
    <div>Settings and configurations</div>
  )
}
